import { combineEpics, type Epic } from 'redux-observable';
import type { Action } from '../state/actions/types.tsx';
import type { State } from '../state/types.tsx';
import { componentDeleted, dialogDisplayed, failure, cancel } from './callbacks.tsx';
import {
	deleteComponentRequest,
	deleteComponentSafe,
	deleteComponentConfirmed,
} from './delete.tsx';

const rootEpic: Epic<Action, State> = combineEpics(
	deleteComponentRequest,
	deleteComponentSafe,
	deleteComponentConfirmed,
	dialogDisplayed,
	componentDeleted,
	failure,
	cancel,
);

export default rootEpic;
